import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";


export default function ChannelProgramBasicInfoComponent({ selectedChannelProgram, handleInnerFormChange }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                );
              }}
              type="text"
              value={selectedChannelProgram?.Name}
            />
             <InputContainer
              label="Channel ProgramCode"
              labelField="ChannelProgramCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code',

                );
              }}
              type="text"
              value={selectedChannelProgram?.Code}
            />
                  <InputContainer
              label="Active"
              labelField="IsActive"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsActive',

                );
              }}
              type="checkbox"
              value={selectedChannelProgram?.IsActive}
            />
 <div className='col-span-full'>
              <InputContainer
            
                          label="Description"
                          name="Description"
                          onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'Description',

                              );
                            }}
                          type="rte"
                          value={selectedChannelProgram?.Description}
                        /></div>
          </div>

        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />

    </>
  )
}